// extracted by mini-css-extract-plugin
export var cartContainer = "_nx-4";
export var gray = "_nx-1";
export var itemContainer = "_nx-2";
export var itemDetails = "_nx-3";
export var strong = "_nx-0";